module.exports = __webpack_public_path__ + "img/icon_ok.7f61e900.svg";